import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { MallaSeguridadComponent } from './MallaSeguridad.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'MallaSeguridad',
        component: MallaSeguridadComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'MallaSeguridad',
          nombreFormulario : 'MallaSeguridad'
        } 
    }
];

@NgModule({
    declarations: [
        MallaSeguridadComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        MallaSeguridadComponent
    ]
})

export class MallaSeguridadModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/MallaSeguridad/MallaSeguridad.module.ts